import React, {useContext} from "react";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {AuthContext} from "../../context/AuthContext";

import AdminCSGORoll from "./admin/AdminCSGORoll";
import AdminRoobet from "./admin/AdminRoobet";
import AdminPackdraw from "./admin/AdminPackdraw";
import AdminClash from "./admin/AdminClash";
import AdminShuffleLeaderboard from "./admin/AdminShuffleLeaderboard";
import AdminCSGORollKazlic from "./admin/AdminCSGORollKazlic";
import AdminHypedropSloth from "./admin/AdminHypedropSloth";
import AdminShuffle from "./admin/AdminShuffle";
import AdminHypedropKazlic from "./admin/AdminHypedropKazlic";
import AdminLuxdrop from "./admin/AdminLuxdrop";
import AdminStake from "./admin/AdminStake";
import AdminCsgobig from "./admin/AdminCsgobig";

const AdminIndex = () => {

    const location = useLocation();
    const navigate = useNavigate();

    return (
        <div>
            <div className='container mt-5 mb-5'>

                <div className="row">
                    <div className="col-md-3">
                        <div className="card text-bg-dark">
                            <div className="card-header">Menu</div>
                            <ul className="list-group list-group-flush">
                                <a href="#" onClick={()=>navigate('/admin/csgo-roll')} className="list-group-item list-group-item-action" aria-current="true">
                                    CSGO Roll (SLOTH)
                                </a>
                                <a href="#" onClick={()=>navigate('/admin/hypedrop-sloth')} className="list-group-item list-group-item-action" aria-current="true">
                                    Hypedrop (SLOTH)
                                </a>
                                <a href="#" onClick={()=>navigate('/admin/hypedrop-kazlic')} className="list-group-item list-group-item-action" aria-current="true">
                                    Hypedrop (Kazlic)
                                </a>
                                <a href="#" onClick={()=>navigate('/admin/csgo-roll-kazlic')} className="list-group-item list-group-item-action" aria-current="true">
                                    CSGO Roll (Kazlic)
                                </a>
                                {/*<a href="#" onClick={()=>navigate('/admin/roobet')} className="list-group-item list-group-item-action" aria-current="true">*/}
                                {/*    Roobet*/}
                                {/*</a>*/}
                                {/*<a href="#" onClick={()=>navigate('/admin/clashgg')} className="list-group-item list-group-item-action" aria-current="true">*/}
                                {/*    ClashGG*/}
                                {/*</a>*/}
                                <a href="#" onClick={()=>navigate('/admin/shuffle')} className="list-group-item list-group-item-action" aria-current="true">
                                    Shuffle
                                </a>
                                <a href="#" onClick={()=>navigate('/admin/luxdrop')} className="list-group-item list-group-item-action" aria-current="true">
                                    Luxdrop
                                </a>
                                <a href="#" onClick={()=>navigate('/admin/stake')} className="list-group-item list-group-item-action" aria-current="true">
                                    Stake
                                </a>
                                <a href="#" onClick={()=>navigate('/admin/csgobig')} className="list-group-item list-group-item-action" aria-current="true">
                                    CSGO:BIG
                                </a>
                            </ul>
                        </div>

                    </div>
                    <div className="col-md-9">
                        <Routes location={location}>
                            <Route path="csgo-roll" element={<AdminCSGORoll />} />
                            <Route path="hypedrop-sloth" element={<AdminHypedropSloth />} />
                            <Route path="hypedrop-kazlic" element={<AdminHypedropKazlic />} />
                            <Route path="csgo-roll-kazlic" element={<AdminCSGORollKazlic />} />
                            <Route path="roobet" element={<AdminRoobet />} />
                            <Route path="clashgg" element={<AdminClash />} />
                            <Route path="shuffle" element={<AdminShuffle />} />
                            <Route path="luxdrop" element={<AdminLuxdrop />} />
                            <Route path="stake" element={<AdminStake />} />
                            <Route path="csgobig" element={<AdminCsgobig />} />
                        </Routes>
                    </div>
                </div>


            </div>

        </div>
    );
}

export default AdminIndex;